<template>
  <a-table
    class="dataTabsTable"
    bordered
    :columns="tableData.columns"
    :data-source="tableData.data"
    :pagination="tableData.pagination"
    :scroll="{y: 'calc(100% - 43px)'}"
  >
    <template slot="actions" slot-scope="text, record">
      <a href="javascript:;" @click="() => showDetail(record)">详情</a>
    </template>
  </a-table>
</template>
<script>
export default {
  props: {
    model: Object
  },
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            width: 50
          },
          {
            title: '任务编号',
            dataIndex: 'name',
            align: 'left'
          },
          {
            title: '任务名称',
            dataIndex: 'name2',
            align: 'left'
          },
          {
            title: '操作类型',
            dataIndex: 'name3',
            align: 'left'
          },
          {
            title: '出入库类型',
            dataIndex: 'name4',
            align: 'left'
          },
          {
            title: '任务状态',
            dataIndex: 'name5',
            align: 'left'
          },
          {
            title: '创建人',
            dataIndex: 'name6',
            align: 'left'
          },
          {
            title: '操作时间',
            dataIndex: 'name7',
            align: 'left'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'left'
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: []
    }
  },
  watch: {
    model: {
      handler (model) {
        this.initValueDetail(model)
      },
      immediate: true
    }
  },
  methods: {
    initValueDetail () {
      for (let i = 0; i < 99; i++) {
        this.analogData.push(
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          }
        )
      }
      this.tableData.data = this.analogData
    },
    showDetail () {}
  }
}
</script>

<style lang="less" scoped>
.dataTabsTable {
  height: 100%;
  /deep/.ant-spin-nested-loading {
    height: 100%;
    .ant-spin-container {
      height: 100%;
      .ant-table {
        height: calc(100% - 64px);
        .ant-table-content {
          height: 100%;
          .ant-table-scroll {
            height: 100%;
            .ant-table-placeholder {
              border-right: 1px solid #b9deff;
              border-bottom: 1px solid #b9deff;
              border-top: 1px solid #b9deff;
            }
          }
        }
      }
      .ant-table-pagination {
        margin-right: 5px;
      }
    }
  }
}
.table /deep/ .ant-table-thead > tr > th {
  background: rgba(8, 64, 159, 0.1);
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
/deep/.biographicalInformationTable  {
  >.ant-spin-nested-loading {
    >.ant-spin-container {
      >.ant-table-pagination.ant-pagination {
        margin-bottom: 10px !important;
        margin-right: 10px !important;
      }
    }
  }
}
.searchManagement {
  margin: 0 !important;
  .searchInput {
    padding: 10px 0 10px 12px !important;
  }
}
</style>
